import './App.css';
import './styles/global.scss';
import ComingSoon from './pages/ComingSoon';

function App() {
  return <ComingSoon />;
}

export default App;
